<template>
  <div v-if="isVisible">
    <el-submenu v-if="hasDisplayChildren" :index="submenuIndex">
      <template slot="title">
        <i :class="item.icon || 'el-icon-menu'"></i>
        <span>{{ item.name }}</span>
      </template>
      <sidebar-item
        v-for="child in displayChildren"
        :key="child.id || child.path || child.name"
        :item="child"
      />
    </el-submenu>
    <el-menu-item v-else-if="item.path" :index="menuItemIndex">
      <i :class="item.icon || 'el-icon-menu'"></i>
      <span>{{ item.name }}</span>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    // 只展示有 path 或有子菜单的节点（过滤掉纯按钮权限节点）
    displayChildren() {
      const children = this.item.children || [];
      return children.filter(c => c.path || (c.children && c.children.length > 0));
    },
    hasDisplayChildren() {
      return this.displayChildren.length > 0;
    },
    isVisible() {
      return this.hasDisplayChildren || !!this.item.path;
    },
    submenuIndex() {
      return 'menu-' + (this.item.id != null ? this.item.id : this.item.name || '');
    },
    menuItemIndex() {
      const path = this.item.path;
      if (!path) return '';
      return path.startsWith('/') ? path : '/' + path;
    }
  }
};
</script>

